import axios, { AxiosResponse } from "axios";
import { ICreatePdfRequest } from "src/infrastructure/interfaces";

async function createPDF(
    request: ICreatePdfRequest
): Promise<AxiosResponse<any>> {
    // Establish base settings for pdf creation
    const renderingOptions = {
        base: "file://",
        height: "11in",
        width: "8.5in",
    };

    // Set document specific settings
    if (request.isPrintDownload) {
        switch (request.type) {
            case "Catalog":
                renderingOptions.width = "9in";
                renderingOptions.height = "11.5in";
                break;
            case "Brochure":
                renderingOptions.width = "16.5in";
                renderingOptions.height = "10.5in";
                break;
            case "Bulletin":
                renderingOptions.width = "9in";
                renderingOptions.height = "11.5in";
                break;
            case "Postcard":
                renderingOptions.width = "9.5in";
                renderingOptions.height = "6.5in";
                break;
            case "Poster":
                renderingOptions.width = "36.5in";
                renderingOptions.height = "24.5in";
                break;
        }
    } else {
        switch (request.type) {
            case "Catalog":
                renderingOptions.width = "8.5in";
                renderingOptions.height = "11in";
                break;
            case "Brochure":
                renderingOptions.width = "16in";
                renderingOptions.height = "10in";
                break;
            case "Bulletin":
                renderingOptions.width = "8.5in";
                renderingOptions.height = "11in";
                break;
            case "Postcard":
                renderingOptions.width = "9in";
                renderingOptions.height = "6in";
                break;
            case "Poster":
                renderingOptions.width = "36in";
                renderingOptions.height = "24in";
                break;
        }
    }

    const renderBlob = new Blob([request.content], {
        type: "text/html",
    });

    const formData = new FormData();
    formData.append("render", renderBlob, `${request.name}.html`);
    var annotationJSON = JSON.stringify(request.annotations);
    var annotationBlob = new Blob([annotationJSON], {type: "application/json"});
    formData.append("annotations", annotationBlob, `${request.name}.json`);

    const result = await axios.post("/pdf", formData, {
      responseType: 'blob',
      params: { ...renderingOptions,
        documentId: request.documentId,
        socketId: request.socketID,
        user_id: request.userID,
        user_email: request.userEmail,
        isPrintDownload: request.isPrintDownload,
        }
    });

    return result;
}

async function fetchPDFStyles(): Promise<string> {
    const fetchCssResult = await fetch(
        `${process.env.PUBLIC_URL}/pdfassets/css/pdf.css`
    );
    const css = await fetchCssResult.text();

    // The css returned from the above call is just the raw css and will be used
    // inline with a PDF so it will need to be wrapped with a style tag.
    return `<style>${css}</style>`;
}

export { createPDF, fetchPDFStyles };



// WEBPACK FOOTER //
// ./src/services/PDFService.ts